import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import * as FuseActions from 'app/store/actions';
import { bindActionCreators } from 'redux';

function PaperComponent(props) {
    return (
        // <Draggable>
        <Paper {...props} />
        // </Draggable>
    );
}

class ConfirmationDialog extends React.Component {
    state = { open: false };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    performAction = () => {
        const { action } = this.props;
        action();
        this.handleClose();
    };

    render() {
        const { title, message, disabled, className } = this.props;
        const { open } = this.state;

        return (
            <div className={`${className} `}>
                <Button disabled={disabled} variant="contained" color="primary" className="my-16" aria-label={title} onClick={this.handleClickOpen}>
                    {title}
                </Button>
                <Dialog open={open} onClose={this.handleClose} PaperComponent={PaperComponent} fullWidth maxWidth="sm" aria-labelledby="draggable-dialog-title">
                    <DialogTitle id="draggable-dialog-title">Confirm</DialogTitle>
                    <DialogContent>
                        <DialogContentText className="text-black">{message}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.performAction()} variant="contained" color="secondary">
                            Confirm
                        </Button>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ showMessage: FuseActions.showMessage }, dispatch);
}

export default connect(null, mapDispatchToProps)(ConfirmationDialog);
